export const TANGO_API_CREDENTIALS =
  import.meta.env.TANGO_API_CREDENTIALS || "{}";
export const TANGO_REGIONS = "customers";
export const TANGO_PROGRAMS = "accounts";
export const TANGO_CUSTOMER_ID = import.meta.env.TANGO_CUSTOMER_ID;
export const ZINC_API_KEY = import.meta.env.ZINC_API_KEY || "";
export const TREMENDOUS_API_KEY = import.meta.env.TREMENDOUS_API_KEY || "";
export const TREMENDOUS_ROOT_URL = import.meta.env.TREMENDOUS_ROOT_URL || "";
export const ADMIN_DRAWER_WIDTH = 200;
export const BRAND_ITEM_FIXED_VALUE = "FIXED_VALUE";
export const BRAND_ITEM_VARIABLE_VALUE = "VARIABLE_VALUE";
export const BRAND_CATEGORIES_ALL = "all";
export const BRAND_CATEGORIES = {
  restaurant: "Restaurant",
  retail: "Retail",
  grocery: "Grocery/Convenience",
  entertainment: "Entertainment",
  electronics: "Electronics",
  sports: "Sports/Outdoors",
  travel: "Travel",
};

export const MAX_PURCHASE_PRICE = 7000;
export const MAX_ITEM_COUNT = 8;
export const ERRORS = {
  redemptionCodes: {
    alreadyRedeemed: "This code has already been redeemed",
    missingData: "There was a problem locating the user and/or code",
  },
  purchase: {
    maxItemCountError: `Your purchase cannot have more than ${MAX_ITEM_COUNT} items. Please remove some items in your cart.`,
    maxPurchasePriceError: `Your purchase cannot be for more than $${MAX_PURCHASE_PRICE}. Please remove some items in your cart.`,
  },
};

export const DEFAULT_COMPANY_CONFIG = {
  TANGO_FROM_NAME: "People Are Primary",
  REWARDS_NAME: "Primary Rewards",
  HELP_EMAIL: "helpdesk@peopleareprimary.com",
  WEBSITE_LINK: "paprewards.com",
  PRIMARY_COLOR: "#1473e6",
  PROMO_SUBJECT: "Welcome to Primary Rewards!",
  LOGIN_SUBJECT: "Your passwordless signin!",
  FILE_NAME: "paprewards-logo.png",
  LOGO_WIDTH: "88",
};

export const LOGIN_MESSAGES = {
  INVALID_COMPANY_ID: "Invalid company ID found",
  USER_NOT_FOUND: "User not found",
  USER_FOUND_EMAIL_SENT: "User found - Email sent",
  USER_FOUND_PROMO_EMAIL_SENT: "User found - Promo email sent",
  EMAIL_RECEIVED: "Email received",
  USER_FOUND_DEV: "User found - Dev link generated",
};
